import { render, staticRenderFns } from "./ProfileHome.vue?vue&type=template&id=568e60b6&scoped=true&"
import script from "./ProfileHome.vue?vue&type=script&lang=js&"
export * from "./ProfileHome.vue?vue&type=script&lang=js&"
import style0 from "./ProfileHome.vue?vue&type=style&index=0&id=568e60b6&prod&lang=less&scoped=true&"
import style1 from "./ProfileHome.vue?vue&type=style&index=1&id=568e60b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e60b6",
  null
  
)

export default component.exports